
const apiUrl = process.env.REACT_APP_API_URL;
export const GetBecatsPerEscolaCursSencer = async ( page : string, idcent: string, year: number ) => {
    try {
        const response = await fetch(`${apiUrl}:8073/beques/${idcent}/${year}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': "loop"
            }
        });
        console.log("page ", page)
        if (!response.ok) {
            alert(await response.text());
        }
        const jsonData = await response.json();
        return jsonData;
        
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};